export default "#iframe {\n  min-height: 80vh;\n}"